// Copied into your app by RapidRailsUI (bin/rails rui:update).
// Don't edit this copy: the next update overwrites it. Fix it in the rapid_rails_ui gem.

// Carousel layout arithmetic (0.94.3), no DOM access.

// Tailwind breakpoints, widest first
const BREAKPOINTS = [
  { key: "xl", min: 1280 },
  { key: "lg", min: 1024 },
  { key: "md", min: 768 },
  { key: "sm", min: 640 },
  { key: "base", min: 0 }
]

// items_per_view is 3 or {base: 1, md: 3}; returns a whole number >= 1
export function resolveItemsPerView(raw, viewportWidth) {
  let count
  if (typeof raw === "number") {
    count = raw
  } else if (raw && typeof raw === "object") {
    for (const { key, min } of BREAKPOINTS) {
      if (viewportWidth >= min && raw[key] != null) {
        count = raw[key]
        break
      }
    }
    if (count == null) count = raw.base ?? 1
  } else {
    count = 1
  }
  return Math.max(1, parseInt(count, 10) || 1)
}

// Slide width so `count` slides and the gaps between them fill the track
// exactly. 100/count% ignored the gaps and clipped the last slide by
// (count - 1) * gap.
export function slideBasis(count, gapPx) {
  const gap = Number.isFinite(gapPx) && gapPx > 0 ? gapPx : 0
  if (count <= 1 || gap === 0) return `${100 / count}%`
  return `calc((100% - ${(count - 1) * gap}px) / ${count})`
}

// The active slide is the one whose left edge sits nearest the track's
// scroll position. With several slides in view, "most visible" picked a
// slide entering on the right, so Previous moved forward.
export function nearestIndex(offsets, scrollLeft) {
  let best = 0
  let bestDistance = Infinity
  offsets.forEach((offset, i) => {
    const distance = Math.abs(offset - scrollLeft)
    if (distance < bestDistance) {
      best = i
      bestDistance = distance
    }
  })
  return best
}

// Next or previous start index. The last reachable start is count - perView:
// past it the browser clamps the scroll and Next would stall instead of
// wrapping. Returns null when there's nowhere to go.
export function stepIndex({ active, count, perView = 1, direction, loop = true }) {
  if (count <= 0) return null
  const last = Math.max(0, count - Math.max(1, perView))
  const current = Math.min(Math.max(0, active), last)
  const target = current + (direction < 0 ? -1 : 1)
  if (target > last) return loop ? 0 : null
  if (target < 0) return loop ? last : null
  return target
}

// Scroll positions the arrows and dots can reach. 3 slides with 3 in view
// is 1 (nothing to do, so no controls); 6 with 3 in view is 4.
export function positionCount(count, perView = 1) {
  return Math.max(1, count - Math.max(1, perView) + 1)
}
